<template>
  <div id="app">
    <preloader v-if="!isLoading"/>
    <keep-alive v-else>
      <router-view/>
    </keep-alive>
  </div>
</template>
<script>
import Preloader from '@/components/Preloader'
export default {
  components: {Preloader},
  data () {
    return {
      isLoading: false
    }
  },
  created () {
    if (typeof window !== 'undefined') {
      window.requestAnimationFrame(this.checkReadyState)
    }
  },
  methods: {
    checkReadyState () {
      if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'complete' && !this.isLoading) {
          setTimeout(() => {
            this.isLoading = true
          }, 200)
        } else {
          window.requestAnimationFrame(this.checkReadyState)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue